import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { countries, devConfig, profile } from 'config/config'; // Importing configuration data

/**
 * Class representing the FilterBalanceHistoryView.
 * @extends JetView
 */
export default class FilterBalanceHistoryView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text', // Text input for User ID
                            name: 'UserId',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'), // Translated label
                            hidden: !devConfig.getPermAction(
                                'filterByUser',
                                'Add', // Permission check for displaying this field
                            ),
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'), // Placeholder text
                        },
                        {
                            view: 'text', // Text input for date selection
                            minWidth: 200,
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Creación'), // Translated label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'datepicker', // Datepicker for selecting a date
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Creación'), // Translated label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum date selectable is today
                                },
                            },
                        },
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            minWidth: 200,
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Translated label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Custom template for displaying country flags
                                        );
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            hidden:
                                devConfig.getCountryReport() ||
                                !devConfig.getPermAction(
                                    'filterByCountry',
                                    'Add', // Permission check for displaying this field
                                ),
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect', // Dropdown for selecting if it's a proprietary sales point
                            name: 'BetShopOwn',
                            minWidth: 200,
                            label: _('Punto de venta propio?'), // Translated label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                { id: 'S', value: _('Si') }, // Option for 'Yes'
                                { id: 'N', value: _('No') }, // Option for 'No'
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'radio', // Radio buttons for selecting type
                            name: 'Type',
                            id: 'Type',
                            label: _('Tipo'), // Translated label
                            labelPosition: 'top',
                            minWidth: 200,
                            height:
                                screen.width < 500 || screen.height < 500
                                    ? 90 // Adjust height based on screen size
                                    : 0,
                            value: 1, // Default selected value
                            options: [
                                { id: 1, value: _('Totales') }, // Option for 'Totals'
                                { id: 0, value: _('Detallado') }, // Option for 'Detailed'
                            ],
                        },
                        {
                            view: 'combo', // Dropdown for sorting options
                            name: 'Sort',
                            label: _('Ordenar por'), // Translated label
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                { id: '1', value: _('Calc. Desfase') }, // Sorting option
                                { id: '2', value: _('GGR. Deportivas') }, // Sorting option
                                { id: '3', value: _('GGR. Casino') }, // Sorting option
                                { id: '4', value: _('Fecha de Creación') }, // Sorting option
                            ],
                            value: '1', // Default selected value
                        },
                        {
                            view: 'combo', // Dropdown for selecting order direction
                            name: 'Dir',
                            label: _('Orden'), // Translated label
                            labelPosition: 'top',
                            minWidth: 200,
                            options: [
                                { id: '0', value: _('Ascendente') }, // Option for 'Ascending'
                                { id: '1', value: _('Descendente') }, // Option for 'Descending'
                            ],
                            value: '0', // Default selected value
                        },
                        { id: 'grav', gravity: 1 }, // Gravity for layout management
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Including the left section in the upper section
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Button to clear the form
                    value: _('Limpiar'), // Translated label
                    width: 100,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                    },
                },
                {
                    view: 'button', // Button to submit the form
                    value: _('Consultar'), // Translated label
                    hotkey: 'enter', // Hotkey for submission
                    type: 'form',
                    width: 110,
                    id: 'consultDesk',
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('balanceHistory:filter', [
                            filterdata, // Trigger filter event with form data
                        ]);
                        $$('b5').collapse(); // Collapse the filter section
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Button to clear the second form
                    value: _('Limpiar'), // Translated label
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues()); // Reset form values
                    },
                },
                {
                    view: 'button', // Button to submit the second form
                    value: _('Consultar'), // Translated label
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('balanceHistory:filter', [
                            filterdata, // Trigger filter event with form data
                        ]);
                        $$('filterPopup').hide(); // Hide the filter popup
                    },
                },
            ],
        };
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for collapsible sections
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Translated header for filters
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for the filter popup
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Include upper section
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Translated label for filters
                    {
                        view: 'icon', // Close icon for the popup
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Include accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for form
                },
            },
        });
        return {
            view: 'form', // Main form view
            id: 'myForm',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Show accordion section on larger screens
                    : { height: 1, width: 0 }, // Placeholder for smaller screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object passed to the init method.
     */
    init(grid) {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date input if typeDate is not 2
                $$('Datepicker').show(); // Show Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show Date input if typeDate is 2
                    $$('Datepicker').hide(); // Hide Datepicker
                }
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
